<template>
  <div class="d-flex w-full align-center">
    <span class="title font-weight-regular">Produtos</span>

    <v-spacer />

    <div class="d-flex align-center pt-1">
      <slot name="right.prepend"></slot>

      <v-switch
        v-model="apenas_itens_ativos"
        hide-details
        class="mt-1 mr-5"
        color="#A51B32"
        :disabled="disabled"
      >
        <template #label>
          <span class="ml-2">Apenas produtos ativos</span>
        </template>
      </v-switch>

      <filtro-por-nivel-de-estoque
        v-model="nivelEstoque"
        :itens-object="niveisDeEstoque"
        class="mr-5"
        dense
        :disabled="disabled"
        style="width: 250px"
      ></filtro-por-nivel-de-estoque>

      <v-text-field
        v-model="pesquisa"
        label="Pesquisar"
        hide-details
        clearable
        dense
        :disabled="disabled"
        append-icon="mdi-magnify"
        style="width: 350px"
        @keyup="verificarPesquisa($event)"
        @input="verificarPesquisa()"
        ></v-text-field>

      <v-btn
        v-if="!tela_cheia"
        icon
        class="ml-3"
        @click="telaCheia = ! telaCheia"
      >
        <v-icon v-if="!telaCheia" small>$Maximixar</v-icon>
        <v-icon v-else>mdi-fullscreen-exit</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import FiltroPorNivelDeEstoque from "./FiltroPorNivelDeEstoque";
import NiveisDeEstoque from "./NiveisDeEstoque";
import {mapGetters} from "vuex";

export default {
  name: "TopDataTable",
  model: {
    prop: "model_value",
    event: "update:model_value"
  },
  components: {
    FiltroPorNivelDeEstoque,
  },
  mixins: [NiveisDeEstoque],
  props: {
    model_value: {
      type: Boolean,
      required: true
    },
    produtos: Array,
    tela_cheia: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    reset_filtros_top: Boolean
  },
  data: () => ({
    apenas_itens_ativos: true,
    pesquisa: '',
    nivelEstoque: '',
    timerPesquisaKeyPress: null
  }),
  computed: {
    ...mapGetters({
      GRUPO_COMPRAS: "usuario/getGrupoCompras",
    }),
    telaCheia: {
      get: function () {
        return this.model_value;
      },
      set: function (valor) {
        this.$emit("update:model_value", valor);
      }
    }
  },
  watch: {
    tela_cheia(valor) {
      this.telaCheia = valor;
    },
    apenas_itens_ativos(valor) {
      this.$emit('update:apenas_itens_ativos', valor)
    },
    nivelEstoque(valor) {
      this.$emit('update:nivel-estoque',  valor)
    },
    reset_filtros_top(valor) {
      if (valor) {
        this.apenas_itens_ativos = false;
        this.pesquisa = '',
        this.$emit('update:txt-pesquisa', this.pesquisa);
        this.nivelEstoque = '';
        this.$emit('update:reset_filtros_top', false);
      }
    }
  },
  methods: {
    verificarPesquisa(evento = '') {
      if (evento.key === 'Enter') {
        this.$emit('update:txt-pesquisa', this.pesquisa);
      } else {
        clearTimeout(this.timerPesquisaKeyPress);
        this.timerPesquisaKeyPress = setTimeout(() => { this.$emit('update:txt-pesquisa', this.pesquisa) }, 3000);
      }
    }
  }
}
</script>

<style scoped>

</style>
